import styles from "./scss/main.scss";

import "./js/jquery.fancybox";
import "./js/custom";
